import { useRouter } from "next/router"

export type AuthRegisterRouterQuery = {
  // LINE連携のコード (number used once)
  nonce?: string
  // LINE連携時にエラーだったらテキストが入る
  login_provider_error?: string
  // infra-next のパスが入る
  redirect_after_auth?: string
  // redirect_after_auth にモーダルを開いた状態でアクセスさせたいときに使う
  // ex.) openModal=selectSchedule
  openModal?: string
  // emailを自動で入力済みにする
  email?: string
  // redirect_after_auth に自動リダイレクトするかどうか
  auto_redirect?: string
  // 広告経由のキャンペーンを判断するパラメータ
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  gad_source?: string
}

export const useAuthRegisterRouterQuery = (): AuthRegisterRouterQuery => {
  const router = useRouter()
  return router.query as AuthRegisterRouterQuery
}
